module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "week-row",
    on: {
      "click": _vm.showWeekNumber
    }
  }, [(_vm.showWeekNumberFlag) ? _c('div', {
    staticClass: "week-number"
  }, [_vm._v(_vm._s(_vm.$t('generic.week')) + " " + _vm._s(_vm.week[0].date.format('w')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.week), function(day, index) {
    return _c('day', {
      key: index,
      attrs: {
        "day": day
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57354b87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Week.vue
// module id = 143
// module chunks = 0 1